import auth from './auth';
import users from './users';
import clients from './clients';
import segments from './segments';
import lockers from './lockers';
import locations from './locations';
import orders from './orders';
import products from './products';
import stats from './stats';
import reports from './reports';
import templates from './templates';

export {
    auth,
    users,
    clients,
    segments,
    lockers,
    locations,
    orders,
    products,
    stats,
    reports,
    templates
};

export default {
    auth,
    users,
    clients,
    segments,
    lockers,
    locations,
    orders,
    products,
    stats,
    reports,
    templates
};
